import { render, staticRenderFns } from "./ListAttr.vue?vue&type=template&id=064754f7&scoped=true&"
import script from "./ListAttr.vue?vue&type=script&lang=js&"
export * from "./ListAttr.vue?vue&type=script&lang=js&"
import style0 from "@/styles/table-styles.css?vue&type=style&index=0&id=064754f7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064754f7",
  null
  
)

export default component.exports